import { render, staticRenderFns } from "./DsfPptPoster.vue?vue&type=template&id=1da0300c&"
import script from "./DsfPptPoster.vue?vue&type=script&lang=js&"
export * from "./DsfPptPoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/control/DsfPptPoster.vue"
export default component.exports